// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".agreement[data-v-f34fc770]{background-color:#fff;font-size:1em;font-weight:400;padding:20px 30px;line-height:2em}.agreement .title[data-v-f34fc770]{text-align:center;font-size:2em;font-weight:700;margin-bottom:1em}.agreement .title-sub[data-v-f34fc770]{font-weight:700;font-size:1.5em}.agreement .text-bold[data-v-f34fc770]{font-weight:700}.agreement .indent[data-v-f34fc770]{text-indent:2em}.agreement .test-underline[data-v-f34fc770]{font-weight:700;text-decoration:underline}", ""]);
// Exports
module.exports = exports;
